<div class="card">
  <div class="card-body">
    <div class="row mb-3">
      <label class="col-form-label col-auto">
        <i class="bi bi-search me-1"></i>ค้นหาประวัติการลงทะเบียนแบบกลุ่มคืนสิทธิ
      </label>
    </div>
    <hr>
    <div class="row mb-3">
      <label class="col-form-label col-lg-3">วันที่ลงทะเบียน วันที่</label>
      <div class="col-lg-3">
        <gt-ng-datepicker></gt-ng-datepicker>
      </div>
      <label class="col-form-label col-lg-3">ถึงวันที่</label>
      <div class="col-lg-3">
        <gt-ng-datepicker></gt-ng-datepicker>
      </div>
    </div>
    <div class="row mb-3">
      <label class="col-form-label col-lg-3">ประเภท</label>
      <div class="col-lg-3">
        <select id="terminal" class="form-select">
          <option selected>ลงทะเบียนสิทธิ UC ล่วงหน้า</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-xl-12 text-center align-content-center justify-content-center">
        <button type="submit" class="btn btn-primary me-3">
          <i class="bi bi-search me-1" (click)="search()"></i>ค้นหา
        </button>
        <button type="submit" class="btn btn-outline-secondary me-3" (click)="clear()">
          <i class="bi bi-eraser-fill me-2"></i>เคลียร์ข้อมูล
        </button>
      </div>
    </div>
  </div>
</div>

<div class="card custom-box mt-3">
  <div class="card-header">
    <p class="ms-2 pt-3">ผลการค้นหาตามเงื่อนไขรายการที่ 0 - 0 จากทั้งหมด 0 รายการ</p>
  </div>
  <div class="row mb-3">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead class="text-center">
        <tr>
          <th scope="col" class="align-middle" nowrap>ลำดับ</th>
          <th scope="col" class="align-middle" nowrap>หน่วยบริการ</th>
          <th scope="col" class="align-middle" nowrap>วันที่ส่งข้อมูล</th>
          <th scope="col" class="align-middle" nowrap>จำนวนทั้งหมด</th>
          <th scope="col" class="align-middle" nowrap>จำนวนที่ผ่าน</th>
          <th scope="col" class="align-middle" nowrap>จำนวนที่ไม่ผ่าน</th>
          <th scope="col" class="align-middle" nowrap>จำนวน UC Proc error</th>
          <th scope="col" class="align-middle" nowrap>รหัสเครือข่ายบริการ</th>
          <th scope="col" class="align-middle" nowrap>จังหวัดที่ลงทะเบียน</th>
          <th scope="col" class="align-middle" nowrap>หน่วยบริการปฐมภูมิ</th>
          <th scope="col" class="align-middle" nowrap>หน่วยบริการที่รับส่งต่อ</th>
          <th scope="col" class="align-middle" nowrap>หน่วยบริการประจำ</th>
          <th scope="col" class="align-middle" nowrap>ไฟล์ข้อมูลการลงทะเบียน</th>
          <th scope="col" class="align-middle" nowrap>ไฟล์ที่ประมวลผล</th>
        </tr>
        </thead>
        <tbody>
        <td colspan="14">
          <app-not-found></app-not-found>
        </td>
        </tbody>
      </table>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-12">
      <ngb-pagination class="d-flex justify-content-center"
                      [maxSize]="5"
                      [rotate]="true"
                      [ellipses]="false"
                      [boundaryLinks]="true"
                      [page]="pageData?.number + 1"
                      (pageChange)="search($event)"
                      [pageSize]="pageData?.size"
                      [collectionSize]="pageData?.totalElements"></ngb-pagination>
    </div>
  </div>
</div>
